import { render, staticRenderFns } from "./GenericWordsPreview.vue?vue&type=template&id=2c0e7796&lang=pug&"
import script from "./GenericWordsPreview.vue?vue&type=script&lang=js&"
export * from "./GenericWordsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports